import { useEffect, useState } from 'react';
import SVG from 'react-inlinesvg';
import classnames from 'classnames/bind';

import { useInterval } from '@autopass-web/domain';
import { Button, Dialog } from '@autopass-web/mochi-component';

import useAppStore from '../../pages/use-app';
import amplitude from '../../service/amplitude';
import { fuelHelper } from '../../utils/fuel-helper';
import { countDownFormatHelper } from '../../utils/time-helper';
import styles from './index.module.sass';
const cx = classnames.bind(styles);

const RefuelingRequest = () => {
  const appStore = useAppStore();
  const {
    id,
    expiresIn,
    gasStationName,
    requestAmount,
    discountAmount,
    amount,
    quantity,
    sku,
    orderReceiptInfo,
  } = appStore.refuelingRequest;
  const isShow = appStore.refuelingRequest !== null;
  const [countDownTime, setCountDownTime] = useState(expiresIn);

  useEffect(() => {
    amplitude.refueling_request_pageview();
  }, []);

  useInterval(() => {
    if (countDownTime === 0) {
      appStore.refuelingRequestTimeout();
    } else {
      setCountDownTime((prev) => prev - 1);
    }
  }, 1000);

  const ReceiptRemind = () => {
    if (!orderReceiptInfo.issuerType || orderReceiptInfo.issuerType === '')
      return <></>;

    const text = () => {
      switch (orderReceiptInfo.issuerType) {
        case 'autopass':
          return '發票自動存入設定載具';
        case 'partner':
          return '現場開立發票，交易後請記得索取';
        default:
          return '';
      }
    };

    return (
      <>
        <hr />
        <div className={styles.remind}>
          <SVG src="/assets/info-outlined.svg" width={16} height={16} />
          {text()}
        </div>
      </>
    );
  };

  const layoutClass = cx({
    layout: true,
    show: isShow,
  });

  return (
    <>
      <div className={layoutClass}>
        <div className={styles.refuelingRequest}>
          <img
            className={styles.close}
            src="/assets/close.svg"
            onClick={() => {
              amplitude.cancel_refueling_request();
              appStore.rejectRefuelingRequest(id);
            }}
            alt="close"
          />
          <div className={styles.title}>
            是否同意授權{gasStationName}使用麻吉付扣款？
          </div>
          <div className={styles.content}>
            <div className={styles.refuelingList}>
              <div className={styles['name']}>品名</div>
              <div className={styles['name-info']}>{fuelHelper(sku)}</div>
              <div className={styles['count']}>數量</div>
              <div className={styles['count-info']}>{`${Number(
                quantity,
              )}公升`}</div>
              <div className={styles['total']}>小計</div>
              <div className={styles['total-info']}>{`$${Number(amount)}`}</div>
              <div className={styles['discount']}>折扣</div>
              <div className={styles['discount-info']}>{`-$${Math.abs(
                Number(discountAmount),
              )}`}</div>
              <div className={styles['payment']}>付款金額</div>
              <div className={styles['payment-info']}>{`$${Number(
                requestAmount,
              )}`}</div>
            </div>
            <ReceiptRemind />
          </div>
          <Button
            size="full"
            type="solid-round"
            theme="yellow"
            onClick={() => {
              amplitude.accept_refueling_request();
              appStore.acceptRefuelingRequest(id);
            }}
          >
            同意付款
          </Button>
          <div className={styles.subText}>
            此交易授權邀請將在 {countDownFormatHelper(countDownTime)} 後失效
          </div>
        </div>
      </div>
      <Dialog
        show={appStore.isRefuelingRequestProcessing}
        title="付款中，請稍候..."
        message="正在與銀行取得授權中，為了您的交易安全，請耐心等待約 10 秒，交易馬上就完成囉！"
      />
    </>
  );
};

const RefuelingRequestDialog = () => {
  const appStore = useAppStore();
  return appStore.refuelingRequest !== null ? <RefuelingRequest /> : <></>;
};

export default RefuelingRequestDialog;
